import React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import library from "../../../assets/images/green_street.jpg";

const ColorButton = styled(Button)(() => ({
  color: "#071783",
  width: 185,
  height: 55,
  fontWeight: 700,
  fontSize: "16px",
  textTransform: "capitalize",
  backgroundColor: "#F2C844",
  borderColor: "#F2C844",
  "&:hover": {
    color: "#071783",
    backgroundColor: "#fff",
    borderColor: "#fff",
  },
}));

const Events = () => {
  return (
    <Box>
      <Grid
        container
        display={"flex"}
        alignItems={"center"}
        margin={{ xs: "0%", sm: "5% 0%" }}
      >
        <Grid
          item
          xs={12}
          sm={6}
          margin={{ xs: "25% 0% 10% 0%", sm: "0%" }}
          display={{ xs: "none", sm: "block" }}
        >
          <Box
            component="img"
            height={{ xs: "45vh", sm: "600px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={library}
            alt={"image"}
            sx={{
              objectFit: "cover",
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          padding={{ xs: "15% 0% 25% 0%", sm: "0% 0% 3% 6%" }}
          marginBottom={{ xs: "0%", sm: "0%" }}
        >
          <Typography
            variant={"h3"}
            fontWeight={400}
            textAlign={"left"}
            color={"#F2C844"}
            paddingBottom={"4%"}
          >
            Upcoming Event
          </Typography>
          <Box
            component="img"
            height={{ xs: "45vh", sm: "600px" }}
            width={{ xs: "100%", sm: "100%" }}
            display={{ xs: "block", sm: "none" }}
            marginTop={{ xs: "10%", sm: "0%" }}
            src={library}
            alt={"image"}
            sx={{
              objectFit: "cover",
            }}
          />
          <Typography
            variant={"h6"}
            fontWeight={400}
            textAlign={"left"}
            paddingTop={{ xs: "10%", sm: "0%" }}
            color={"#fff"}
            paddingBottom={"1%"}
          >
            Green Streets: Taking Actions for a Cleaner Tomorrow
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#F2C844"}
            paddingBottom={"1%"}
          >
            March 29, 2025
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#fff"}
            padding={{ xs: "5% 0% 2% 0%", sm: "4% 0% 0% 0%" }}
            lineHeight={1.5}
          >
            Join us for an inspiring session with a remarkable entrepreneur who
            has built a thriving outdoor catering business using recycled
            materials. Her journey is a powerful example of innovation,
            sustainability, and resourcefulness in business.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#fff"}
            padding={{ xs: "1% 0%", sm: "4% 0% 0% 0%" }}
            lineHeight={1.5}
          >
            This event is designed to ignite the minds of young entrepreneurs
            and changemakers in our community. Through her story, participants
            will gain practical insights into building creative business models,
            integrating sustainability into their ventures, and turning everyday
            challenges into opportunities.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={700}
            textAlign={"left"}
            color={"#fff"}
            padding={{ xs: "1% 0%", sm: "4% 0% 0% 0%" }}
            lineHeight={1.5}
          >
            Don't miss this opportunity to learn from a trailblazer who is
            redefining what it means to build with purpose. Her experience will
            not only inspire but also empower the next generation to lead with
            impact.
          </Typography>
          {/* <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#F2C844"}
            padding={{ xs: "2% 0%", sm: "2% 0% 0% 0%" }}
            lineHeight={1.5}
          >
       
          </Typography> */}
          <Box marginTop={"4%"}>
            <ColorButton
              component={"a"}
              variant="contained"
              target="_blank"
              size="medium"
              href={"https://forms.gle/vNa9fETPFSEhD2oE7"}
            >
              Register Now
            </ColorButton>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Events;
